interface InputFielProps {
  as: "input" | "textarea";
  size: "md" | "lg";
  value: string;
  placeholder: string;
  maxLength: number | "unlimited";
  disabled: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  customClassName?: string;
  rows?: number;
  type?: React.HTMLInputTypeAttribute;
}

const baseClass = "box-border w-full rounded-lg outline-none transition-colors duration-150 ease-out border border-gray-300 placeholder:text-gray-300 focus:border-primaryVar-500 disabled:bg-gray-100 disabled:cursor-not-allowed";

const inputSizeClasses = {
  md: "h-10 px-3 text-sm",
  lg: "h-12 px-4 text-base",
};

const textareaSizeClasses = {
  md: "px-3 py-2 text-sm",
  lg: "px-4 py-3 text-base",
};

export default function InputFiel({ as, size, value, placeholder, maxLength,  disabled, onChange, customClassName, rows, type = "text" }: InputFielProps) {

  const Component = as;

  const resolvedMaxLength = maxLength === "unlimited" ? undefined : maxLength;

  const sizeClass = as === "textarea" ? textareaSizeClasses[size] : inputSizeClasses[size];

  const className = [
    baseClass,
    sizeClass,
    as === "textarea" && "resize-none",
    customClassName,
  ].filter(Boolean).join(" ");

  return (
    <Component
      value={value}
      placeholder={placeholder}
      maxLength={resolvedMaxLength}
      rows={as === "textarea" ? rows : undefined}
      disabled={disabled}
      onChange={onChange}
      className={className}
      {...(as === "input" ? { type } : {})}
    />
  );
};